import { SvgIcon } from "@progress/kendo-react-common";
import { checkboxIcon, sortAscSmallIcon } from "@progress/kendo-svg-icons";
import { FunctionComponent } from "react";
import { Zone } from "../api";
import { numberUtils } from "../number-utils";
import { VerticalLabel } from "./VerticalLabel";
import classes from "./ZoneArea.module.scss";

export const ZoneArea: FunctionComponent<{ zone: Zone }> = ({ zone }) => {
  const getSpot = (index: number) => {
    if (!zone.Spots || !zone.AvailableSpaceLengths) {
      return;
    }

    return (
      <div key={index} className={classes.spot}>
        <SvgIcon
          svgClassName="checkbox"
          size="xxlarge"
          icon={checkboxIcon}
          style={{
            visibility: zone.Spots[index].MeterCode ? "visible" : "hidden",
          }}
        />
        <span className={classes.code}>
          {zone.Spots[index].MeterCode ?? zone.Spots[index].Code}
        </span>
        <SvgIcon svgClassName="checkbox" size="xxlarge" icon={checkboxIcon} />
        <VerticalLabel className={classes["vertical-header"]}>
          {numberUtils.toInches(zone.AvailableSpaceLengths[index])}'
        </VerticalLabel>
      </div>
    );
  };

  return (
    <div className={classes.content}>
      <div className={classes.header}>
        <SvgIcon svgClassName="k-rotate-90" icon={sortAscSmallIcon} />
        {zone.Width && (
          <>
            <span>{numberUtils.toInches(zone.Width)}'</span>&nbsp;
          </>
        )}
        <span className="bold">{zone.StreetSide}</span>
        <SvgIcon svgClassName="k-rotate-90" icon={sortAscSmallIcon} />
      </div>
      <div className={classes.body}>
        <VerticalLabel className={classes["vertical-header"]}>
          <span className="bold">{zone.Code}</span>
        </VerticalLabel>
        <div className={classes.inventory}>
          <div className={classes.zone} style={{ backgroundColor: zone.Color }}>
            <SvgIcon
              svgClassName="checkbox"
              size="xxlarge"
              icon={checkboxIcon}
            />
          </div>
          <div className={classes.spots}>
            {zone.NumSpaces &&
              zone.AvailableSpaceLengths &&
              zone.Spots &&
              Array.from({ length: zone.NumSpaces }, (_, index) =>
                getSpot(index)
              )}
          </div>
        </div>
        <VerticalLabel className={classes["vertical-header"]}>
          <SvgIcon svgClassName="k-rotate-270" icon={sortAscSmallIcon} />
          <span>{numberUtils.toInches(zone.Length)}'</span>&nbsp;
          <span className="bold">{zone.Direction}</span>
          <SvgIcon svgClassName="k-rotate-270" icon={sortAscSmallIcon} />
        </VerticalLabel>
      </div>
    </div>
  );
};
